import { useEffect } from "react";
import "../assets/css/cleaner.css";

const Cleaner = () => {
    useEffect(() => {
        //멤버 검색 id : string
        const wrap = document.querySelector("#wrap");
        let searchId;
        document.querySelectorAll(".search")[0].addEventListener("click", function () {
            const userId = document.querySelectorAll(".searchVal")[0].value;
            const userList = document.querySelectorAll(".user_list")[0];
            if (userId.length > 0 && searchId !== userId) {
                searchId = userId;
                appendUserInfo();
            } else if (userId.length == 0) {
                alert("유저 ID를 입력해주세요");
            } else if (searchId == userId) {
                alert("같은 아이디 검색");
            }
            function appendUserInfo() {
                if (document.querySelectorAll(".user_list li")[0]) {
                    document.querySelectorAll(".user_list li")[0].remove();
                }
                fetch(`https://api.segimedu.com/api/admin/getTargetUserInfo?user_id=${userId}`)
                    .then(function (res) {
                        return res.json();
                    })
                    .then(function (data) {
                        const db = data.data[0];
                        let searchDb;
                        // let prevSearchHistory;
                        userList.insertAdjacentHTML("beforeend", `<li><h4>아래 정보를 지닌 회원의 학습 기록을 검색하시려면 버튼을 눌러주세요</h4><p><span> mdEmail : ${db.mb_email} </span> <span> mbName : ${db.mb_name} </span> <span> mbNo : ${db.mb_no} </span> <button class="searchHistory">학습기록 조회</button> <p></li>`);
                        document.querySelectorAll(".searchHistory")[0].addEventListener("click", function () {
                            if (searchDb !== db) {
                                searchDb = db;
                                if (document.querySelectorAll(".history_result_wrapper li")[0]) {
                                    document.querySelectorAll(".history_result_wrapper li").forEach((item) => {
                                        item.remove();
                                    });
                                }
                                if (document.querySelectorAll(".history_result_wrapper button")[0]) {
                                    document.querySelectorAll(".history_result_wrapper button")[0].remove();
                                }
                                const deleteBtn = document.querySelectorAll(".history_result_wrapper")[0].insertAdjacentHTML("afterbegin", `<button class="delete">선택 삭제하기</button> `);
                                const choiceBtn = document.querySelectorAll(".history_result_wrapper")[0].insertAdjacentHTML("afterbegin", `<button class="select_all">전체 선택하기</button> `);
                                const listTitle = document.querySelectorAll(".history_result_wrapper ul")[0].insertAdjacentHTML("beforeend", `<li class="history_title"><span>번호</span><span> 생성된 시간</span> <span> MB 번호 </span> <span> 데이터 값 </span> <span> Book Id </span> </li> `);
                                fetch(`https://api.segimedu.com/api/admin/getTargetUserLearningHistory?mb_no=${db.mb_no}`)
                                    .then(function (res) {
                                        return res.json();
                                    })
                                    .then(function (data) {
                                        data.data.forEach((item, idx) => {
                                            document.querySelectorAll(".history_result_wrapper ul")[0].insertAdjacentHTML("beforeend", `<li idx=${idx + 1}><input onChange type="checkbox" /> <span>${idx + 1}</span> <span historyId=${item.id}> created_at : ${item.created_at}</span> <span> md_no : ${item.mb_no}</span> <span> mb_open_data : ${item.ss_learning_module_id}</span><span>${item.ss_book_id}</span> </li> `);
                                        });
                                        const checkList = document.querySelectorAll(".history_result_wrapper li");
                                        checkList.forEach((item, idx) => {
                                            item.addEventListener("click", function (e) {
                                                if (e.target.tagName !== "INPUT") {
                                                    const clickBox = document.querySelectorAll(" .history_result_wrapper li input[type = 'checkbox']")[idx - 1];
                                                    clickBox.checked == true ? (clickBox.checked = false) : (clickBox.checked = true);
                                                }
                                            });
                                        });
                                        document.querySelectorAll(".select_all")[0].addEventListener("click", () => {
                                            const checkBox = document.querySelectorAll("input[type = 'checkbox']");
                                            const clickCheckBox = document.querySelectorAll("input[type = 'checkbox']:checked")
                                            checkBox.forEach(item => {
                                                if (checkBox.length > clickCheckBox.length) {
                                                    item.checked = true
                                                } else {
                                                    if (item.checked) {
                                                        item.checked = false
                                                    } else {
                                                        item.checked = true
                                                    }
                                                }
                                            })
                                        })
                                        deleteRows();
                                    });
                            } else {
                                alert("같은 기록을 조회했습니다.");
                            }
                        });
                    });
            }
        });

        function deleteRows() {
            const idArr = [];
            document.querySelectorAll(".delete")[0].addEventListener("click", () => {
                const checkBox = document.querySelectorAll("input[type = 'checkbox']:checked");

                checkBox.forEach((item) => {
                    let checkHistoryId = item.nextElementSibling.nextElementSibling.getAttribute("historyId");
                    idArr.push(checkHistoryId);
                });
                let formdata = new FormData();

                idArr.forEach((item) => {
                    formdata.append("history_id", item);
                });

                fetch(`https://api.segimedu.com/api/admin/deleteTargetUserLearningHistory`, {
                    method: "POST",
                    body: formdata,
                })
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (data) {
                        if (data.success == true) {
                            alert("삭제되었습니다.");
                            window.location.reload(true);
                            // checkBox.forEach((item) => {
                            //     let checkIdx = item.parentNode.getAttribute("idx");
                            //     item.parentNode.remove();
                            //     alert(`${checkIdx}번째 기록이 삭제되었습니다.`);
                            // })
                        }
                    });
            });
        }
    }, []);

    return (
        <div id="wrap">
            <div className="search_row">
                <h4>학습 기록을 조회하고 싶은 회원의 아이디를 입력해주세요</h4>
                <input type="text" placeholder="유저 검색" className="searchVal" />
                <button className="search">검색하기 </button>
            </div>

            <ul className="user_list"></ul>
            <div className="history_result_wrapper">
                <ul></ul>
            </div>
        </div>
    );
};

export default Cleaner;
